import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { cmsApi, oneAssetApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var MainService = /** @class */ (function () {
    function MainService(http) {
        this.http = http;
        this.announceFavNumSource = new Subject();
        this.favNumAnnounce$ = this.announceFavNumSource.asObservable();
        this.checkMonth = [
            {
                number: 1,
                name: 'มกราคม'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์'
            },
            {
                number: 3,
                name: 'มีนาคม'
            },
            {
                number: 4,
                name: 'เมษายน'
            },
            {
                number: 5,
                name: 'พฤษภาคม'
            },
            {
                number: 6,
                name: 'มิถุนายน'
            },
            {
                number: 7,
                name: 'กรกฎาคม'
            },
            {
                number: 8,
                name: 'สิงหาคม'
            },
            {
                number: 9,
                name: 'กันยายน'
            },
            {
                number: 10,
                name: 'ตุลาคม'
            },
            {
                number: 11,
                name: 'พฤศจิกายน'
            },
            {
                number: 12,
                name: 'ธันวาคม'
            }
        ];
    }
    MainService.prototype.announceFavNum = function (favNum) {
        this.announceFavNumSource.next(favNum);
    };
    MainService.prototype.changeFormatDate = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month; })[0];
        return day + ' ' + monthTh['name'] + ' ' + year;
    };
    MainService.prototype.getBanner = function () {
        var URL = cmsApi + '/get_banner_active';
        var body = {};
        return this.http.post(URL, body);
    };
    MainService.prototype.getBannerPrivate = function () {
        var URL = cmsApi + '/get_banner_private_fund';
        var body = {};
        return this.http.post(URL, body);
    };
    MainService.prototype.getBannerProvident = function () {
        var URL = cmsApi + '/get_banner_provident';
        var body = {};
        return this.http.post(URL, body);
    };
    MainService.prototype.get_FavNum = function (IP) {
        var URL = cmsApi + '/get_FavNum';
        var body = { IP: IP };
        return this.http.post(URL, body);
    };
    MainService.prototype.date_thai = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month; })[0];
        return (day + ' ' + monthTh['name'] + ' ' + year);
    };
    MainService.prototype.getAnnounce = function () {
        var URL = cmsApi + '/get_announceList_top3';
        var body = {};
        return this.http.post(URL, body);
    };
    MainService.prototype.getFundRecomm = function () {
        var URL = cmsApi + '/get_fundRecomList_top3';
        var body = {};
        return this.http.post(URL, body);
    };
    MainService.prototype.getEartUpdate = function () {
        var URL = cmsApi + '/get_earthupdateList_top2';
        var body = {};
        return this.http.post(URL, body);
    };
    MainService.prototype.getPromotion = function () {
        var URL = cmsApi + '/get_promotionList_top1';
        var body = {};
        return this.http.post(URL, body);
    };
    MainService.prototype.getAnnounceByID = function (announce_id) {
        var URL = cmsApi + '/get_announceById';
        var body = { announce_id: announce_id };
        return this.http.post(URL, body);
    };
    MainService.prototype.getmarketByID = function (market_id) {
        var URL = cmsApi + '/get_marketById';
        var body = { market_id: market_id };
        return this.http.post(URL, body);
    };
    MainService.prototype.getEartUpdateByID = function (earthupdateid) {
        var URL = cmsApi + '/get_earthupdateById';
        var body = { earthupdateid: earthupdateid };
        return this.http.post(URL, body);
    };
    MainService.prototype.getpromotionByID = function (promotionid) {
        var URL = cmsApi + '/get_promotionById';
        var body = { promotionid: promotionid };
        return this.http.post(URL, body);
    };
    MainService.prototype.getbenefitByID = function (benefitid) {
        var URL = cmsApi + '/get_benefitById';
        var body = { benefitid: benefitid };
        return this.http.post(URL, body);
    };
    MainService.prototype.get_IsFav = function (IP, fundid, currency) {
        var URL = cmsApi + '/get_IsFav';
        var body = {
            IP: IP,
            fundid: fundid,
            currency: currency
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.add_IsFav = function (IP, fundid, currency) {
        var URL = cmsApi + '/add_IsFav';
        var body = {
            IP: IP,
            fundid: fundid,
            currency: currency
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.delIsFav = function (IP, fundid, currency) {
        var URL = cmsApi + '/delIsFav';
        var body = {
            IP: IP,
            fundid: fundid,
            currency: currency
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.getFundHoliday = function (dateFrom, dateTo) {
        var URL = oneAssetApi + '/Fund/GetFundHoliday';
        var body = {
            dateFrom: dateFrom,
            dateTo: dateTo
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.checkCustomerPID = function (pid, type, source) {
        var URL = oneAssetApi + '/Account/CheckCustomerPID';
        var body = {
            pid: pid,
            type: type,
            source: source
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.checkCustomerOTP = function (pid, type, source, refOTP, otp) {
        var URL = oneAssetApi + '/Account/CheckCustomerOTP';
        var body = {
            pid: pid,
            type: type,
            source: source,
            refOTP: refOTP,
            otp: otp
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.loadConsent = function (uid, pidNo) {
        var path = '/pdpa/GetConsentInfoByAccountAsync/?id=' + pidNo;
        if (uid !== '' && uid !== undefined) {
            path = '/pdpa/GetConsentInfoByUserIdAsync/?id=' + uid;
        }
        var URL = oneAssetApi + path;
        return this.http.get(URL);
    };
    MainService.prototype.sendConsent = function (pid, purposes) {
        var URL = oneAssetApi + '/pdpa/SetConsentInfoByAccountAsync';
        var body = {
            identifier: pid,
            purposes: purposes,
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.getPrivacyPolicy = function () {
        var URL = oneAssetApi + '/Info/PrivacyPolicy';
        return this.http.get(URL);
    };
    MainService.prototype.GetDataRequest = function (pid) {
        var URL = oneAssetApi + '/report/GetDataRequest';
        var body = {
            PIDNo: pid,
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.downloadFilePdf = function (temcod, horder, date, fundlist) {
        var URL = oneAssetApi + '/report/DownloadFilePdf';
        var body = {
            TemplateCode: temcod,
            HolderNo: horder,
            Date: date,
            FundList: fundlist,
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.sendTaxConsent = function (pidNo, isAcceptConsent, year, agentId, language) {
        var URL = oneAssetApi + '/consent/tax';
        var body = {
            pidNo: pidNo,
            agentId: agentId,
            given: isAcceptConsent,
            consentId: '',
            source: 'Web Site',
            type: 'tax',
            year: year,
            language: language,
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.getTaxConsent = function (pidNo, agentId) {
        var URL = oneAssetApi + '/consent/GetTaxConsent';
        var body = {
            pidNo: pidNo,
            agentId: agentId,
            type: 'tax',
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.checkUID = function (uid) {
        var URL = oneAssetApi + '/info/CheckUID';
        var body = {
            uid: uid,
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.sendOneamToPine = function (uid) {
        var URL = oneAssetApi + '/info/OneamToPine';
        var body = {
            uid: uid,
        };
        return this.http.post(URL, body);
    };
    MainService.prototype.GetIndexLevelList = function () {
        var URL = oneAssetApi + '/IndexLevel/GetIndexLevel';
        return this.http.get(URL);
    };
    MainService.ngInjectableDef = i0.defineInjectable({ factory: function MainService_Factory() { return new MainService(i0.inject(i1.HttpClient)); }, token: MainService, providedIn: "root" });
    return MainService;
}());
export { MainService };
